import React, { Component, Suspense } from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import Loadable from "react-loadable";

import Loader from "./layout/Loader";
import ScrollToTop from "./layout/ScrollToTop";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import jwtService from "src/App/services/jwtService.js";

import routes from "src/routes";
import routesAdmin from "src/routes-admin";
import menuItems from "src/menu-items";
import menuItemsAdmin from "src/menu-items-admin";

// Otimização: Importar CSS otimizado para paginação
import "./styles/paginacao-otimizada.css";

const AdminLayout = Loadable({
  loader: () => import("./layout/AdminLayout"),
  loading: Loader,
});

const Login = Loadable({
  loader: () => import("./../App/views/Login/Login"),
  loading: Loader,
});

const LoginAdmin = Loadable({
  loader: () => import("./../App/views/Admin/Login/Login"),
  loading: Loader,
});

const PropostaPublica = Loadable({
  loader: () => import("./../App/views/Proposta/PropostaPublica"),
  loading: Loader,
});

const CondicionalPublicaAceite = Loadable({
  loader: () => import("./../App/views/Condicional/CondicionalPublicaAceite"),
  loading: Loader,
});

class App extends Component {
  constructor(props) {
    super(props);
    jwtService.init();
  }

  render() {
    return (
      <React.Fragment>
        <ScrollToTop>
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/admin" component={LoginAdmin} />
              <Route path="/proposta/:token" component={PropostaPublica} />
              <Route
                path="/condicional/:token"
                component={CondicionalPublicaAceite}
              />
              <Route
                render={(props) =>
                  this.props.isUsuarioAutenticado ? (
                    <AdminLayout {...props} routes={routes} menuItems={menuItems}/>
                  ) : this.props.isAdminAutenticado ? (
                    <AdminLayout {...props} routes={routesAdmin} menuItems={menuItemsAdmin}/>
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />
            </Switch>
          </Suspense>
        </ScrollToTop>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isUsuarioAutenticado: state.auth.usuarioAutenticado,
    isAdminAutenticado: state.auth.adminAutenticado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
